import { CountUp } from 'countup.js';
export const stats = () => {
  var numbers = $('.number');

  $.each(numbers, function (i, e) {
    var numberValue, firstIntIndex, hasPrefix, hasSuffix;

    // get the number from the string
    numberValue = $(this).text().replace(/\D/g, '');

    // get the index of the first number
    firstIntIndex = $(this).text().search(/\d/);

    // if firstIntIndex > 0, then there is a prefix
    if (firstIntIndex > 0) {
      hasPrefix = $(this).text().substring(0, firstIntIndex);
      hasSuffix = $(this).text().replace(/[0-9]/g, '').slice(firstIntIndex);
    } else {
      hasPrefix = false;
      hasSuffix = $(this).text().replace(/[0-9]/g, '');
    }

    var prefix = hasPrefix ? hasPrefix : '';
    var suffix = hasSuffix ? hasSuffix : '';

    // console.log($(this).text())
    // console.log(numberValue)
    // console.log(prefix)
    // console.log(suffix)

    var hasDecimals = numberValue.indexOf('.') == -1 ? 0 : 1;

    var options = {
      startVal: 0,
      useEasing: false,
      useGrouping: true,
      decimal: '.',
      decimalPlaces: hasDecimals,
      // duration       : 3,
      scrollSpyDelay: 0,
      prefix: prefix,
      suffix: suffix,
      enableScrollSpy: true,
    };

    if (numberValue && numberValue > 0) {
      var number = new CountUp($(this)[0], numberValue, options);
    }
  });
};
